module.exports = __webpack_public_path__ + "static/img/game-logo-spribe.1b9151b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-spribe.png
// module id = sXYn
// module chunks = 0 1 2 3 4 5 6